module.exports = __webpack_public_path__ + "static/media/delete-warn.70b41060.svg";